import { Component, HostBinding, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Utils } from '../utils';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentYear = (new Date()).getFullYear();

  @HostBinding('class.site-footer') true;
  public date: string;
  public termsOfUseLink: string = '';
  public privacyLink: string = '';

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    Utils.setUnusualBrowserSettings();
    this.setTermsOfUseLink();
    this.setPrivacyLink();
    this.translate.onLangChange.subscribe(() => {
      this.setTermsOfUseLink();
      this.setPrivacyLink();
    });
  }

  private setTermsOfUseLink(): void {
    this.translate.get('FOOTER.TERMS_OF_USE_LINK').subscribe((link: string) => {
      this.termsOfUseLink = link;
    });
  }

  private setPrivacyLink(): void {
    this.translate.get('FOOTER.PRIVACY_LINK').subscribe((link: string) => {
      this.privacyLink = link;
    });
  }

}
